import { DEFAULT_VITALS } from '../vitals/kinds';
import { DELETE } from '../actions/kinds';

export default {
  actions: [DELETE],
  sections: [],
  vitals: [...DEFAULT_VITALS],
  canEditTitle: true,
};
